module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0011.jpg?v=3d1b0c8d";